// faqドロワー
document.querySelectorAll(".c-faq-box-q__inner").forEach((element) => {
  element.addEventListener("click", () => {
    const answerBox = element.parentNode.querySelector(".c-faq-box-a");
    const questionBox = element.parentNode.querySelector(".c-faq-box-q");

    if (answerBox.classList.contains("is-open")) {
      // 閉じるとき
      answerBox.style.height = `${answerBox.scrollHeight}px`; // 現在の高さを設定
      requestAnimationFrame(() => {
        answerBox.style.height = "0";
      });
    } else {
      // 開くとき
      answerBox.style.height = `${answerBox.scrollHeight}px`; // 自動で高さを設定
    }

    answerBox.classList.toggle("is-open");
    questionBox.classList.toggle("is-open");

    // アニメーション後にheightをリセット
    answerBox.addEventListener(
      "transitionend",
      () => {
        if (!answerBox.classList.contains("is-open")) {
          answerBox.style.height = "";
        }
      },
      { once: true }
    );
  });
});